import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allWorks: null,
    springWorks: null,
    summerWorks: null,
    autumnWorks: null,
    winterWorks: null
  },
  mutations: {
    setAllWorks (state, val) {
      state.allWorks = val
    },
    setSpringWorks (state, val) {
      state.springWorks = val
    },
    setSummerWorks (state, val) {
      state.summerWorks = val
    },
    setAutumnWorks (state, val) {
      state.autumnWorks = val
    },
    setWinterWorks (state, val) {
      state.winterWorks = val
    }
  },
  actions: {
    updateAllWorks ({ commit, state }, val) {
      commit('setAllWorks', val)
    },
    updateSpringWorks ({ commit, state }, val) {
      commit('setSpringWorks', val)
    },
    updateSummerWorks ({ commit, state }, val) {
      commit('setSummerWorks', val)
    },
    updateAutumnWorks ({ commit, state }, val) {
      commit('setAutumnWorks', val)
    },
    updateWinterWorks ({ commit, state }, val) {
      commit('setWinterWorks', val)
    }
  },
  getters: {
    allWorks: (state) => {
      return state.allWorks
    },
    springWorks: (state) => {
      return state.springWorks
    },
    summerWorks: (state) => {
      return state.summerWorks
    },
    autumnWorks: (state) => {
      return state.autumnWorks
    },
    winterWorks: (state) => {
      return state.winterWorks
    }
  },
  modules: {
  }
})
